import { HttpErrorResponse } from '@angular/common/http';

export function getErrorMessage(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    if (typeof error.error === 'string') {
      return error.error;
    }
    if (error.error?.message) {
      return error.error.message;
    }
    if (error.status === 0) {
      return 'Unable to reach the server. Check your connection and try again.';
    }
    if (error.status === 401 || error.status === 403) {
      return 'You do not have access to this company.';
    }
    return `Request failed (${error.status}). Please try again.`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred. Please try again.';
}

export function getCredentialsErrorMessage(error: unknown): string {
  if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
    return 'Incorrect email or password.';
  }

  return getErrorMessage(error);
}
